import { createSlice } from '@reduxjs/toolkit';

const attachmentsSlice = createSlice({
  name: 'attachments',
  initialState: {
    currentAttachments: [],
    newAttachments: [],
    deletedAttachments: [],
    isUploading: false, 
  },
  reducers: {
    setCurrentAttachments: (state, action) => {
      state.currentAttachments = action.payload; 
    },
    addNewAttachment: (state, action) => {
      state.newAttachments.push(action.payload); 
    },
    deleteAttachment: (state, action) => {
      const id = action.payload;
      if (state.newAttachments.includes(id)) {
        state.newAttachments = state.newAttachments.filter((file) => file !== id);
      } else {
        state.deletedAttachments.push(id); 
        state.currentAttachments = state.currentAttachments.filter((file) => file !== id); 
      }
    },
    resetAttachments: (state) => {
      state.currentAttachments = [];
      state.newAttachments = [];
      state.deletedAttachments = [];
    },
    setIsUploading: (state, action) => {
      state.isUploading = action.payload; 
    },
  },
});

export const {
  setCurrentAttachments,
  addNewAttachment,
  deleteAttachment,
  resetAttachments,
  setIsUploading,
} = attachmentsSlice.actions;

export default attachmentsSlice.reducer;